import { IN } from '../constants/measurementUnits';
import { UPDATE_MEASUREMENT_UNIT } from '../actions/measurementUnitActions';

function measurementUnitReducer(state = IN, action) {
    const { type } = action;

    switch (type) {
        case UPDATE_MEASUREMENT_UNIT:
            return action.payload;
        default:
            return state;
    }
}

export default measurementUnitReducer;
